import styled from "styled-components";

export default styled.div`
    width: 100%;
    height: 100%;

    .reportContainer,
    .manualSingInContainer {
        height: 100%;
        width: 100%;
    }

    .loadingSpinner {
        margin-top: 50px;

        .spinner {
            width: 50px;

            svg {
                font-size: 50px;
            }
        }
    }

    iframe {
        border: none;
    }
`; 